import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth0 } from "@auth0/auth0-react";
import { mainRoutes } from './config/routes.config';
import { ProtectedRoute } from './components/ProtectedRoute';

function App() {
  const { isLoading, isAuthenticated, logout } = useAuth0();

  // One-time forced logout: boot each currently-authenticated user exactly
  // once. The localStorage flag survives the logout redirect, so after the
  // user logs back in it's already set and they're never force-logged-out again.
  useEffect(() => {
    if (!isLoading && isAuthenticated && localStorage.getItem('hasLoggedOut') !== 'true') {
      localStorage.setItem('hasLoggedOut', 'true');
      logout({ logoutParams: { returnTo: window.location.origin } });
    }
  }, [isLoading, isAuthenticated, logout]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <Router>
      <Routes>
        {mainRoutes.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={<ProtectedRoute element={route.element} />} 
          >
            {route.children?.map((child) => (
              <Route
                key={child.path}
                index={child.index}
                path={child.path}
                element={<child.element />} 
              />
            ))}
          </Route>
        ))}
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Router>
  );
}

export default App;